import { default as Modal } from './Modal';

/**
 * Component to display a video modal dialog.
 */
export default class extends Modal {
    /**
     * Whether to autoplay the iframe content.
     *
     * @var {boolean}
     */
    autoplay = true;

    /**
     * Creates a new Video Modal component.
     *
     * @param  {object} options - The module options.
     * @throws {TypeError} If the module does not have acceptable markup.
     */
    constructor(options) {
        super(options);

        this.body = this.$('body')[0];

        if (!this.body) {
            throw new TypeError(
                `${this.moduleName} must have a [data-video-modal="body"] element`
            );
        }

        this.errorMessage = this.getData('error-message') || 'An error occurred.';
    }

    /**
     * @inheritdoc
     *
     * This method will flush the embedded media after a delay.
     */
    onHide(/* dialogEl, event */) {
        super.onHide(...arguments);

        if (this.appendDelay) {
            clearTimeout(this.appendDelay);
        }

        this.emptyTimeout = setTimeout(() => {
            this.body.innerHTML = '';
        }, 250);
    }

    /**
     * @inheritdoc
     *
     * This method will inject the embedded media after a delay.
     */
    onShow(dialogEl, event) {
        if (this.emptyTimeout) {
            clearTimeout(this.emptyTimeout);
        }

        const target = event.target.closest('[data-video-modal-id]');

        const host = this.getData('host', target);
        const id   = this.getData('id', target);

        if (!id || !host) {
            this.debug && console.warn('[App.VideoModal] Missing video provider or video ID');
            this.body.innerText = this.errorMessage;
            return;
        }

        this.appendDelay = setTimeout(() => {
            let uri;

            switch (host) {
                case 'youtube':
                    uri = `https://www.youtube.com/embed/${id}`;
                    if (this.autoplay) {
                        uri += '?autoplay=1';
                    }
                    break;

                case 'vimeo':
                    uri = `https://player.vimeo.com/video/${id}?loop=1&autopause=0`;
                    if (this.autoplay) {
                        uri += '&autoplay=1';
                    }
                    break;

                default:
                    this.debug && console.warn('[App.VideoModal] Unrecognized video provider:', host)
                    this.body.innerText = this.errorMessage;
                    return;
            }

            this.body.innerHTML = `<iframe src="${uri}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
        }, 500);

        super.onShow(...arguments);
    }
}
